import { createFileRoute } from "@tanstack/react-router";
import { AuthForm } from "@/knowmeno/AuthGate";

export const Route = createFileRoute("/sign-up")({
  head: () => ({
    meta: [
      { title: "Create your free account — KnowMeno" },
      {
        name: "description",
        content:
          "Create your free KnowMeno account. Track menopause symptoms and build a clinical-grade doctor report. Free forever — no card required.",
      },
      { property: "og:title", content: "Create your free account — KnowMeno" },
      {
        property: "og:description",
        content:
          "Create your free KnowMeno account. Track menopause symptoms and build a clinical-grade doctor report. Free forever — no card required.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://knowmeno.com/sign-up" },
    ],
    links: [{ rel: "canonical", href: "https://knowmeno.com/sign-up" }],
  }),
  component: SignUpPage,
});

function SignUpPage() {
  return <AuthForm mode="signup" />;
}
